import { ControlCreationOptions } from "./ControlCreationOptions";
import { useOptroBulkImportEnabled } from "../../../../hooks/useOptroBulkImportEnabled";

// Shown when the workspace has no controls at all (not for filtered-empty
// results). Mirrors the "Welcome to Midship" mock: the creation entry cards.
export const ControlsWelcomeState = () => {
  const optroBulkImportEnabled = useOptroBulkImportEnabled();
  return (
    <ControlCreationOptions
      title="Welcome to Midship"
      subtitle={
        optroBulkImportEnabled
          ? "Get your control library set up in minutes. Most of your control data already lives in Optro and carries over automatically."
          : "Get your control library set up in minutes."
      }
    />
  );
};
